<template>
  <v-nav/>
  <select-personal @selectPersonal="selectPersonal"/>
  <a-row>
    <a-col :span="6">
      <page-title style="position:fixed;" :brain-type="$t('personalBrain')" :menu-name="$t('electricalPosition')"/>
      <div class="condition-content" style="">
        <div class="option-panel">
          <select-id-and-name :list="personalList" option-text="name" option-value="id" v-model:value="personalId">
          </select-id-and-name>
        </div>
        <div class="option-panel" style="margin-top: 12px">
          <a-checkbox-group v-model:value="list" @change="changeArea">
            <template v-for="item in optionList" :key="item.value">
              <a-checkbox :value="item.value">
                <div style="display: inline-block;height: 10px;width: 10px" :style="{backgroundColor: 'rgb('+ (item.color[0] * 255) +',' + (item.color[1]*255) + ',' + (item.color[2]*255) + ')'}"></div>
                {{ item.label }}
              </a-checkbox>
              <br/>
            </template>
          </a-checkbox-group>
        </div>
        <div class="option-panel" style="margin-top: 12px">
          <div style="width: 100%;text-align: center">
            <a-button @click="download" ghost>{{ $t("dataDownload") }}</a-button>
          </div>
        </div>
      </div>
    </a-col>
    <a-col :span="18">
      <div id="electricalBrain" style="width: 100%" :style="{height:contentHeight}">
      </div>
      <div class="positionContent" v-if="currentPoint != null"
           :style="{top : labelTop +'px', left : labelLeft + 'px'}">
        <a-tag color="purple" style="font-size: 16px">{{ currentPoint.px }}，{{ currentPoint.py }}，{{
            currentPoint.pz
          }}
        </a-tag>
      </div>
    </a-col>
  </a-row>

  <v-loading :show="loading"></v-loading>
</template>

<script>
// zhouhan@cibr.ac.cn 2022/12/14 10:21
import VLoading from "@/components/public/v-loading";
import util from "@/util/util";
import VNav from "@/components/public/VNav.vue";
import SelectPersonal from "@/components/public/selectPersonal.vue";
import PageTitle from "@/components/public/pageTitle.vue";
import vtkUtil from "@/util/vtkUtil";
import SelectIdAndName from "@/components/public/selectIdAndName.vue";
import { Modal } from "ant-design-vue";

export default {
  name: "personalElectrical",
  components: {SelectIdAndName, PageTitle, SelectPersonal, VNav, VLoading},
  data() {
    return {
      loading: false,
      personalId: "",
      contentHeight: "",
      personalList: [],
      pointActorList: [],
      list: [],
      pointPicker: {},
      renderer: null,
      renderWindow: null,
      labelTop: 0,
      labelLeft: 0,
      pickedActor: null,
      pointList: [],
    }
  },
  mounted() {
    // this.initPage();
  },
  beforeMount() {
    this.computedHeight();
  },
  methods: {
    download() {
      // if (util.isNull(this.list)) {
      //   util.error("请选择功能区！");
      //   return;
      // }
      // var text = "";
      // this.pointList.map(item => {
      //   text += item.px + "," + item.py + "," + item.pz + "\n";
      // })
      // var filter = this.optionList.filter(item => this.list.includes(item.value));
      // var name = []
      // filter.map(item => {
      //   name.push(item.label)
      // })
      // util.download_txt(name.join("-") + ".txt", text);
      // util.$post("/home/visitAddress", {type: "01"});
      Modal.info({
        title: this.$t('downloadTip', { email: 'baohongbo1990@hotmail.com' }),
      })
    },
    initPicker() {
      this.pointPicker = vtkUtil.initPicker();
      vtkUtil.bindLeftButtonPress(this.renderWindow, this.renderer, this.pointPicker, "electricalBrain", (res) => {
        this.pickedActor = res.actor;
        var brainContainer = document.getElementById("electricalBrain");
        this.labelTop = brainContainer.getBoundingClientRect().bottom - res.pos.y * 0.8;
        this.labelLeft = brainContainer.getBoundingClientRect().left + res.pos.x * 0.7;
      })
    },
    changeArea() {
      this.clearPoint();
      if (util.isNull(this.list)) {
        return;
      }
      var post = {
        personalId: this.personalId,
        list: JSON.stringify(this.list)
      }
      util.$post("/personal/electrical/getPoints", post, (res) => {
        this.pointList = res.pointList;
        this.drawPoints();
      }, this.showMask, this.hideMask)
    },
    clearPoint() {
      this.pointList = [];
      this.pointActorList.map(item => {
        this.renderer.removeActor(item);
      })
      this.renderWindow.render();
    },
    drawPoints() {
      this.pointActorList = vtkUtil.getSphereActorList(this.pointList, this.renderer);
      this.pointPicker.initializePickList();
      this.pointActorList.map(item => {
        var pointType = item.getProperty().get().cibrPoint.pointtype;
        var color = this.getColor(pointType);
        item.getProperty().setColor(color);
        item.getProperty().set({oldColor: color}, true, true);
        this.pointPicker.addPickList(item);

      })
      this.renderWindow.render();
    },
    getColor(type){
      var filter = this.optionList.filter(item => item.value === type);
      if (filter.length > 0){
        return filter[0].color;
      }
      return [1,0,0]
    },
    computedHeight() {
      this.contentHeight = (window.innerHeight - 48) + "px";
    },
    selectPersonal(personalId) {
      this.personalId = personalId;
      this.drawBrain();
      this.initPage();
    },
    drawBrain() {
      var vtkWindow = vtkUtil.init3DWindow("electricalBrain");
      this.renderer = vtkWindow.renderer;
      this.renderWindow = vtkWindow.renderWindow;
      this.initPicker();
      this.loadBrain();
    },
    loadBrain() {
      this.showMask();
      vtkUtil.readObjMode(util.personalUrl + this.personalId + "/surface.obj",
          this.renderer, this.renderWindow, () => {
            this.hideMask();
          });
    },
    showMask() {
      this.loading = true;
    },
    hideMask() {
      this.loading = false;
    },
    initPage() {
      var post = {
        personalId: this.personalId,
      }
      util.$post("/personal/electrical/initPage", post, (res) => {
        this.personalList = res.personalList;
      }, this.showMask, this.hideMask);
    }
  },
  watch: {
    pickedActor(newVal, oldVal) {
      if (!util.isNull(oldVal)) {
        oldVal.getProperty().setColor(oldVal.getProperty().get().oldColor);
      }
      if (!util.isNull(newVal)) {
        newVal.getProperty().setColor([0, 1, 0]);
      }
      this.renderWindow.render();
    },
    personalId() {
      if (util.isNull(this.renderer)) {
        return;
      }
      this.pickedActor = null;
      this.pointActorList = [];
      this.list = [];
      this.pointList = [];
      this.pointPicker.initializePickList();
      this.renderer.getActors().map(item => {
        this.renderer.removeActor(item);
      })
      this.loadBrain();
    }
  },
  computed: {
    currentPoint() {
      if (util.isNull(this.pickedActor)) {
        return null
      }
      return this.pickedActor.getProperty().get().cibrPoint;
    },
    optionList() {
      var list = [];
      list.push({color: [1, 0.003921, 0],value: "active", label: this.$t("sportsArea")})
      list.push({color: [0.831372, 1, 0.003921],value: "language", label: this.$t("languageArea")})
      list.push({color: [0.007843, 0.501960, 1],value: "feel", label: this.$t("feelArea")})
      list.push({color: [1, 0.835294, 0],value: "other", label: this.$t("otherArea")})
      return list;
    }
  }
}
</script>

<style scoped>
.condition-content {
  /*background-color: #5A2781;*/
  /*border-radius: 20px;*/
  /*border: 1px #552D6D solid;*/
  /*padding: 16px 16px;*/
  position: absolute;
  top: 40px;
  left: 40px;
  margin-top: 120px;
  /*padding: 16px 16px;*/
  width: 200px;
}

.positionContent {
  position: fixed;
  top: 180px;
  left: 250px;
  z-index: 9;
  color: white;
  font-size: 24px;
}

</style>